// extracted by mini-css-extract-plugin
export default {"container":"DataTable_container__qzkR6","table":"DataTable_table__VimPf","tableFootStyle":"DataTable_tableFootStyle__Sj+74"};